import DataTable from "../../../components/common/data-table/data-table";
import {
  USER_REPORT_COLUMNS,
  UserReportReason,
} from "views/user/user-report/user-report-column";
import UserReportForm from "./user-report-form";

interface UserReportProps {
  userId?: string;
}

const UserReport: React.FC<UserReportProps> = ({ userId }) => {
  return (
    <div>
      <DataTable
        tableName="User Reports"
        parentTableName="Users"
        deleteTitle="User Report"
        mainCol=""
        getAllLink="/api/admin/users/report" //TODO add "api" to base rout
        getAllParameters={{ userId: userId }}
        getItemLink="/api/admin/users/report" //TODO add "api" to base rout
        hasEdit={true}
        hasDelete={false}
        updateItemLink="/api/admin/users/report" //TODO add "api" to base rout
        deleteRowLink="/api/admin/users/report" //TODO add "api" to base rout
        tableCols={USER_REPORT_COLUMNS}
        FormContent={UserReportForm}
        tableDataMapper={(rows) => {
          return rows?.map((row: any, index: number) => {
            return {
              ...row,
              reason:
                UserReportReason[row.reason as keyof typeof UserReportReason] ??
                row.reason,
              isParentReport: row?.isParentReport ? "Parent" : "Child",
            };
          });
        }}
        formDataMapper={(data: any) => {
          return {
            ...data,
            status: data?.status?.value,
            reporterType: data?.isParentReport ? "Parent" : "Child",
            reason:
              UserReportReason[data.reason as keyof typeof UserReportReason] ??
              data.reason,
          };
        }}
        formSubmitMapper={(data: any) => {
          return {
            status: data?.status,
          };
        }}
      />
    </div>
  );
};

export default UserReport;
